export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
// Resolve root-relative URLs before RTK Query joins resource paths.
export function resolveApiBaseUrl(configured, origin = window.location.origin) {
  return new URL((configured || '').trim() || '/api/v1', origin).href.replace(/\/+$/, '');
}
export const baseURL = resolveApiBaseUrl(process.env.REACT_APP_BASE_URL);
export const baseSocketURL = process.env.REACT_APP_BASE_SOCKET_URL;
export const isReadOnlyPreview = process.env.REACT_APP_READ_ONLY_PREVIEW === 'true';
